module.exports = {
  UNLICENSED_VISIBLE_SIGN_COUNT: 10
}
